import React, {Component} from 'react';

import styles from './LoginForm.css';
import {Input, FormGroup} from 'reactstrap';
import Button from '../Button/Button'
import Headline from "../Headline/Headline";

export default class LoginForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: ""
        }
    }

    render() {
        const {username, password} = this.state;
        const {loginAction, error} = this.props;

        return (
            <div className={styles.wrapper}>
                <Headline pageTitle>Melden Sie sich an und verwalten<br /> Sie die Termine Ihrer Praxis.</Headline>
                <div className={styles.form}>
                    <FormGroup className={styles.formGroup}>
                        <Input
                            type="text"
                            name="username"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            id="username"
                            placeholder="Benutzer"
                            value={username}
                            onChange={(event) => this.setState({username: event.target.value})}
                        />
                    </FormGroup>
                    <FormGroup className={styles.formGroup}>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Passwort"
                            value={password}
                            onChange={(event) => this.setState({password: event.target.value})}
                        />
                    </FormGroup>

                    <Button block color="success" href={''} onClick={() => loginAction(username, password)}>Login</Button>

                    {
                        error && <p>E-Mail und Passwort stimmen nicht überein.</p>
                    }

                    <div className={styles.btnRegister}>
                        <Button href={'/register'}>Jetzt registrieren</Button>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js